(function() {
    'use strict';
    angular
        .module('telestatApp')
        .factory('OfficePhone', OfficePhone);

    OfficePhone.$inject = ['$resource'];

    function OfficePhone ($resource) {
        var resourceUrl =  'api/office-phones/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
